import { imgSrcAttributes } from 'helpers/common';
import * as React from 'react';

interface IProps {
	images: string[];
}

const OrderProductImages = (props: IProps) => {
	let images = [];
	if (props.images && props.images.length > 0) {
		images = props.images;
	}

	const data = images.slice(0, 3);
	const imagesList = data.map((img, i) => {
		return <img className="orderImage" {...imgSrcAttributes(img)} key={`orderImage-${i}`} />;
	});

	if (images.length > 3) {
		imagesList.push(<div className="orderImage">+3</div>);
	}

	return <div className="orderImages">{imagesList}</div>;
};

export { OrderProductImages };
